module.exports = __webpack_public_path__ + "static/media/Background.9605043c.png";